module.exports = __webpack_public_path__ + "static/media/8.b8354096.JPG";